export const SET_STORE_STATUS_START = 'SET_STORE_STATUS_START';
export const SET_STORE_STATUS_SUCCESS = 'SET_STORE_STATUS_SUCCESS';
export const SET_STORE_STATUS_ERROR = 'SET_STORE_STATUS_ERROR';
export const CLEAR_SET_STORE_STATUS = 'CLEAR_SET_STORE_STATUS';
